import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

// Enum options extracted from Ruby CountryConcern::Enums

// 1. Currency enum
export const currencyOptions = [
  { value: "AED", label: "AED" },
  { value: "AFN", label: "AFN" },
  { value: "ALL", label: "ALL" },
  { value: "AMD", label: "AMD" },
  { value: "ANG", label: "ANG" },
  { value: "AOA", label: "AOA" },
  { value: "ARS", label: "ARS" },
  { value: "AUD", label: "AUD" },
  { value: "AWG", label: "AWG" },
  { value: "AZN", label: "AZN" },
  { value: "BAM", label: "BAM" },
  { value: "BBD", label: "BBD" },
  { value: "BDT", label: "BDT" },
  { value: "BGN", label: "BGN" },
  { value: "BHD", label: "BHD" },
  { value: "BIF", label: "BIF" },
  { value: "BMD", label: "BMD" },
  { value: "BND", label: "BND" },
  { value: "BOB", label: "BOB" },
  { value: "BOV", label: "BOV" },
  { value: "BRL", label: "BRL" },
  { value: "BSD", label: "BSD" },
  { value: "BTN", label: "BTN" },
  { value: "BWP", label: "BWP" },
  { value: "BYN", label: "BYN" },
  { value: "BZD", label: "BZD" },
  { value: "CAD", label: "CAD" },
  { value: "CDF", label: "CDF" },
  { value: "CHE", label: "CHE" },
  { value: "CHF", label: "CHF" },
  { value: "CHW", label: "CHW" },
  { value: "CLF", label: "CLF" },
  { value: "CLP", label: "CLP" },
  { value: "CNY", label: "CNY" },
  { value: "COP", label: "COP" },
  { value: "COU", label: "COU" },
  { value: "CRC", label: "CRC" },
  { value: "CUC", label: "CUC" },
  { value: "CUP", label: "CUP" },
  { value: "CVE", label: "CVE" },
  { value: "CZK", label: "CZK" },
  { value: "DJF", label: "DJF" },
  { value: "DKK", label: "DKK" },
  { value: "DOP", label: "DOP" },
  { value: "DZD", label: "DZD" },
  { value: "EGP", label: "EGP" },
  { value: "ERN", label: "ERN" },
  { value: "ETB", label: "ETB" },
  { value: "EUR", label: "EUR" },
  { value: "FJD", label: "FJD" },
  { value: "FKP", label: "FKP" },
  { value: "GBP", label: "GBP" },
  { value: "GEL", label: "GEL" },
  { value: "GHS", label: "GHS" },
  { value: "GIP", label: "GIP" },
  { value: "GMD", label: "GMD" },
  { value: "GNF", label: "GNF" },
  { value: "GTQ", label: "GTQ" },
  { value: "GYD", label: "GYD" },
  { value: "HKD", label: "HKD" },
  { value: "HNL", label: "HNL" },
  { value: "HRK", label: "HRK" },
  { value: "HTG", label: "HTG" },
  { value: "HUF", label: "HUF" },
  { value: "IDR", label: "IDR" },
  { value: "ILS", label: "ILS" },
  { value: "INR", label: "INR" },
  { value: "IQD", label: "IQD" },
  { value: "IRR", label: "IRR" },
  { value: "ISK", label: "ISK" },
  { value: "JMD", label: "JMD" },
  { value: "JOD", label: "JOD" },
  { value: "JPY", label: "JPY" },
  { value: "KES", label: "KES" },
  { value: "KGS", label: "KGS" },
  { value: "KHR", label: "KHR" },
  { value: "KMF", label: "KMF" },
  { value: "KPW", label: "KPW" },
  { value: "KRW", label: "KRW" },
  { value: "KWD", label: "KWD" },
  { value: "KYD", label: "KYD" },
  { value: "KZT", label: "KZT" },
  { value: "LAK", label: "LAK" },
  { value: "LBP", label: "LBP" },
  { value: "LKR", label: "LKR" },
  { value: "LRD", label: "LRD" },
  { value: "LSL", label: "LSL" },
  { value: "LYD", label: "LYD" },
  { value: "MAD", label: "MAD" },
  { value: "MDL", label: "MDL" },
  { value: "MGA", label: "MGA" },
  { value: "MKD", label: "MKD" },
  { value: "MMK", label: "MMK" },
  { value: "MNT", label: "MNT" },
  { value: "MOP", label: "MOP" },
  { value: "MRU", label: "MRU" },
  { value: "MUR", label: "MUR" },
  { value: "MVR", label: "MVR" },
  { value: "MWK", label: "MWK" },
  { value: "MXN", label: "MXN" },
  { value: "MXV", label: "MXV" },
  { value: "MYR", label: "MYR" },
  { value: "MZN", label: "MZN" },
  { value: "NAD", label: "NAD" },
  { value: "NGN", label: "NGN" },
  { value: "NIO", label: "NIO" },
  { value: "NOK", label: "NOK" },
  { value: "NPR", label: "NPR" },
  { value: "NZD", label: "NZD" },
  { value: "OMR", label: "OMR" },
  { value: "PAB", label: "PAB" },
  { value: "PEN", label: "PEN" },
  { value: "PGK", label: "PGK" },
  { value: "PHP", label: "PHP" },
  { value: "PKR", label: "PKR" },
  { value: "PLN", label: "PLN" },
  { value: "PYG", label: "PYG" },
  { value: "QAR", label: "QAR" },
  { value: "RON", label: "RON" },
  { value: "RSD", label: "RSD" },
  { value: "RUB", label: "RUB" },
  { value: "RWF", label: "RWF" },
  { value: "SAR", label: "SAR" },
  { value: "SBD", label: "SBD" },
  { value: "SCR", label: "SCR" },
  { value: "SDG", label: "SDG" },
  { value: "SEK", label: "SEK" },
  { value: "SGD", label: "SGD" },
  { value: "SHP", label: "SHP" },
  { value: "SLL", label: "SLL" },
  { value: "SOS", label: "SOS" },
  { value: "SRD", label: "SRD" },
  { value: "SSP", label: "SSP" },
  { value: "STN", label: "STN" },
  { value: "SVC", label: "SVC" },
  { value: "SYP", label: "SYP" },
  { value: "SZL", label: "SZL" },
  { value: "THB", label: "THB" },
  { value: "TJS", label: "TJS" },
  { value: "TMT", label: "TMT" },
  { value: "TND", label: "TND" },
  { value: "TOP", label: "TOP" },
  { value: "TRY", label: "TRY" },
  { value: "TTD", label: "TTD" },
  { value: "TWD", label: "TWD" },
  { value: "TZS", label: "TZS" },
  { value: "UAH", label: "UAH" },
  { value: "UGX", label: "UGX" },
  { value: "USD", label: "USD" },
  { value: "USN", label: "USN" },
  { value: "UYI", label: "UYI" },
  { value: "UYU", label: "UYU" },
  { value: "UYW", label: "UYW" },
  { value: "UZS", label: "UZS" },
  { value: "VES", label: "VES" },
  { value: "VND", label: "VND" },
  { value: "VUV", label: "VUV" },
  { value: "WST", label: "WST" },
  { value: "XAF", label: "XAF" },
  { value: "XAG", label: "XAG" },
  { value: "XAU", label: "XAU" },
  { value: "XBA", label: "XBA" },
  { value: "XBB", label: "XBB" },
  { value: "XBC", label: "XBC" },
  { value: "XBD", label: "XBD" },
  { value: "XCD", label: "XCD" },
  { value: "XDR", label: "XDR" },
  { value: "XOF", label: "XOF" },
  { value: "XPD", label: "XPD" },
  { value: "XPF", label: "XPF" },
  { value: "XPT", label: "XPT" },
  { value: "XSU", label: "XSU" },
  { value: "XTS", label: "XTS" },
  { value: "XUA", label: "XUA" },
  { value: "XXX", label: "XXX" },
  { value: "YER", label: "YER" },
  { value: "ZAR", label: "ZAR" },
  { value: "ZMW", label: "ZMW" },
  { value: "GBX", label: "GBX" },
  { value: "CNH", label: "CNH" },
];

// 2. Continent enum
export const continentOptions = [
  { value: "0", label: "Africa" },
  { value: "1", label: "Asia" },
  { value: "2", label: "Europe" },
  { value: "3", label: "Middle East" },
  { value: "4", label: "North America" },
  { value: "5", label: "Pacific" },
  { value: "6", label: "South America" },
  { value: "7", label: "Various" },
];

// 3. Economical Zone enum
export const economicalZoneOptions = [
  { value: "0", label: "Alena" },
  { value: "1", label: "Asean" },
  { value: "2", label: "Brics" },
  { value: "3", label: "EEA Ex Eurozone" },
  { value: "4", label: "Other" },
  { value: "5", label: "Eurozone" },
];

// 4. EMU OECD Zone enum
export const emuOecdZoneOptions = [
  { value: "0", label: "EMU" },
  { value: "1", label: "OECD Ex EMU" },
  { value: "2", label: "Other" },
];

// 5. Market Group enum
export const marketGroupOptions = [
  { value: "0", label: "Africa" },
  { value: "1", label: "Caribbean" },
  { value: "2", label: "Central America" },
  { value: "3", label: "Eastern Europe" },
  { value: "4", label: "Eurozone" },
  { value: "5", label: "Japan" },
  { value: "6", label: "Middle East" },
  { value: "7", label: "Nordics" },
  { value: "8", label: "North America" },
  { value: "9", label: "North Asia" },
  { value: "10", label: "Pacific" },
  { value: "11", label: "South America" },
  { value: "12", label: "South Asia" },
  { value: "13", label: "South East Asia" },
  { value: "14", label: "Switzerland" },
  { value: "15", label: "Turkey" },
  { value: "16", label: "United Kingdom" },
  { value: "17", label: "Various" },
  { value: "18", label: "Western Europe" },
];

// 6. Market Type enum
export const marketTypeOptions = [
  { value: "0", label: "Developed Markets" },
  { value: "1", label: "Emerging Markets" },
  { value: "2", label: "Frontier Markets" },
  { value: "3", label: "Various" },
];

// Zod schema
export const filterCountriesSchema = z.object({
  code_contains: z.string().nullable().optional(),
  economical_zone: z.coerce.number().optional(),
  market_group: z.coerce.number().optional(),
  market_type: z.coerce.number().optional(),
  continent: z.coerce.number().optional(),
  currency_contains: z.string().nullable().optional(),
  emu_oecd_zone: z.coerce.number().optional(),
});

export type FilterCountriesSchema = z.infer<typeof filterCountriesSchema>;

export const fields: Field[] = [
  {
    name: "code_contains",
    label: "Code",
    type: "input",
  },
  {
    name: "economical_zone",
    label: "Economical Zone",
    type: "select",
    useTranslation: false,
    options: economicalZoneOptions,
  },
  {
    name: "market_group",
    label: "Market Group",
    type: "select",
    useTranslation: false,
    options: marketGroupOptions,
  },
  {
    name: "market_type",
    label: "Market Type",
    type: "select",
    useTranslation: false,
    options: marketTypeOptions,
  },
  {
    name: "continent",
    label: "Continent",
    type: "select",
    useTranslation: false,
    options: continentOptions,
  },
  {
    name: "currency_contains",
    label: "Currency",
    type: "select",
    useTranslation: false,
    options: currencyOptions,
  },
  {
    name: "emu_oecd_zone",
    label: "EMU OECD Zone",
    type: "select",
    useTranslation: false,
    options: emuOecdZoneOptions,
  },
];

export const client = "qtl - referential";
export const tableName = "countries";

export function FilterCountries() {
  return (
    <FilterTable
      client={client}
      schema={filterCountriesSchema}
      tableName={tableName}
      customBuildPath={() => `${client}/${tableName}`}
      fields={fields}
    />
  );
}
